import React from "react";
import { Chart } from "../components";
import useInterval from "../hooks/useInterval";

export default function Dashboard() {
  const [amount, updateAmount] = React.useState(153);
  var digits = amount.toString().split("");

  useInterval(() => updateAmount((anount) => amount + 0.0001165), 100);
  return (
    <div className="bg-gradient-to-br from-blue-500 to-blue-400 h-screen flex flex-col items-center p-10">
      {/* <Chart /> */}
      <h1 className="text-2xl font-semibold text-white tracking-tighter">
        Welcome back, Artist
      </h1>
      <h1 className="font-semibold text-white">your fund is worth:</h1>
      <div className="grid grid-cols-3 auto-cols-fr text-5xl font-semibold text-white items-end">
        <span></span>
        <div>
          <span>£{digits.map((amount) => amount).splice(0, 6)}</span>
          <span className="text-lg">
            {digits.map((amount) => amount).splice(6, 5)}
          </span>
        </div>
        <span></span>
      </div>
      <div className="bg-white p-5 rounded-md m-5">
        <table className="table-auto w-full">
          <thead className="text-left">
            <tr>
              <th>Date of event</th>
              <th>Chapel Venue</th>
              <th>Attendance</th>
              <th>Ticket Price</th>
              <th>Total revenue</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>28/05/2021</td>
              <td>Venue A</td>
              <td>300px</td>
              <td>£10</td>
              <td>£3000</td>
            </tr>
            <tr>
              <td>14/04/2021</td>
              <td>Venue D</td>
              <td>300px</td>
              <td>£10</td>
              <td>£3000</td>
            </tr>
            <tr>
              <td>12/01/2021</td>
              <td>Venue C</td>
              <td>300px</td>
              <td>£10</td>
              <td>£3000</td>
            </tr>
            <tr>
              <td>03/06/2020</td>
              <td>Venue OG</td>
              <td>300px</td>
              <td>£10</td>
              <td>£3000</td>
            </tr>
            <tr>
              <td>01/04/2020</td>
              <td>Venue B</td>
              <td>300px</td>
              <td>£10</td>
              <td>£3000</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
